import p1 from "./Pimg/7up 500ml N1000.jpg"
import p2 from "./Pimg/Aquafina 700ml N1000.jpg"
import p3 from "./Pimg/BBQ Chicken Pizza N13,220.jpg"
import p4 from "./Pimg/BBQ Mega Meat Pizza N13,760.jpg"
import p5 from "./Pimg/Breadsticks N5,800.jpg"
import p6 from "./Pimg/Chicken Stuffed Cheesy Bread N7,000.jpg"
import p7 from "./Pimg/Chicken Supreme Pizza N11,220.jpg"
import p8 from "./Pimg/Chicken Suya Pizza N13,220.jpg"
import p9 from "./Pimg/Cinnastix N5,800.jpg"
import p10 from "./Pimg/Cinnastix N5,800.jpg"
import p11 from "./Pimg/Extravaganza Pizza N13,760.jpg"
import p12 from "./Pimg/Margherita Pizza N12,320.jpg"
import p13 from "./Pimg/Melted Choco Pockets N4,840.jpg"
import p14 from "./Pimg/Mirinda Orange 500ml N1,000.jpg"
import p15 from "./Pimg/Naija Fiesta Pizza N13,760.jpg"
import p16 from "./Pimg/PET Supa Komado Energy Drink 300ml N1,000.jpg"
import p17 from "./Pimg/Pepsi 500ml N1,000.jpg"
import p18 from "./Pimg/Shawarma Pizza N13,760.jpg"
import p19 from "./Pimg/Southern Style BBQ Chicken N14,220.jpg"
import p20 from "./Pimg/Suya BBQ Mix Grill Pizza N13,760.jpg"
import p21 from "./Pimg/Teen Bitter Lemon 500ml N1,000.jpg"
import p22 from "./Pimg/The Lot N13,760.jpg"
import p23 from "./Pimg/Veggie Supreme Pizza N12,320.jpg"






const products = [

  
  {
    id: 7,
    name: "Chicken Supreme Pizza",
    category: "chicken",
    price: 11300,
    image: p7 ,
    shopId: "shop015",
    shopName: "Dominos Pizza",
    
      vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
  },
  {
    id: 8,
    name: "Chicken Suya Pizza",
    category: "chicken",
    price: 13220,
    image: p8 ,
    shopId: "shop015",
    shopName: "Dominos Pizza",
    
      vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
  },
  {
    id: 9,
    name: "Cinnastix",
    category: "sides",
    price: 5800,
    image: p9 ,
    shopId: "shop015",
    shopName: "Dominos Pizza",
    
      vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
  },
  {
    id: 10,
    name: "Cinnastix",
    category: "sides",
    price: 5800,
    image: p10 ,
    shopId: "shop015",
    shopName: "Dominos Pizza",
    
      vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
  },
  {
    id: 11,
    name: "Extravaganza Pizza",
    category: "loaded",
    price: 13760,
    image: p11 ,
      shopId: "shop015",
      shopName: "Dominos Pizza",
    
      vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
  },
  {
    id: 12,
    name: "Margherita Pizza ",
    category: "veggie",
    price: 12400,
    image: p12 ,
    shopId: "shop015",
    shopName: "Dominos Pizza",
    
      vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
  },
  {
    id: 13,
    name: "Melted Choco Pockets",
    category: "sides",
    price: 4900,
    image: p13 ,
    shopId: "shop015",
    shopName: "Dominos Pizza",
    
      vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
  },
  {
    id: 14,
    name: "Mirinda Orange 500ml",
    category: "drinks",
    price: 1000,
    image: p14 ,
    shopId: "shop015",
    shopName: "Dominos Pizza",
    
      vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
  },
   
    {
      id: 1,
      name: "7up 500ml",
      category: "drinks",
      price: 1000,
      image: p1 ,
        shopId: "shop015",
        shopName: "Dominos Pizza",
      
        vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
    },
    {
      id: 2,
      name: "Aquafina 700ml",
      category: "drinks",
      price: 1000,
      image: p2 ,
      shopId: "shop015",
      shopName: "Dominos Pizza",
      
        vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
    },
    {
      id: 3,
      name: "BBQ Chicken Pizza",
      category: "chicken",
      price: 13220,
      image: p3 ,
      shopId: "shop015",
      shopName: "Dominos Pizza",
      
        vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
    },
    {
      id: 4,
      name: "BBQ Mega Meat Pizza",
      category: "meat",
      price: 13760,
      image: p4 ,
      shopId: "shop015",
      shopName: "Dominos Pizza",
      
        vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
    },
    {
      id: 5,
      name: "Breadsticks",
      category: "sides",
      price: 5800,
      image: p5 ,
      shopId: "shop015",
      shopName: "Dominos Pizza",
      
        vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
    },
    {
      id: 6,
      name: "Chicken Stuffed Cheesy Bread",
      category: "sides",
      price: 7000,
      image: p6 ,
      shopId: "shop015",
      shopName: "Dominos Pizza",
      
        vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
    },
   
    {
      id: 15,
      name: "Naija Fiesta Pizza .jpg",
      category: "loaded",
      price: 13760,
      image: p15 ,
      shopId: "shop015",
      shopName: "Dominos Pizza",
      
        vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
    },
    {
      id: 16,
      name: "PET Supa Komado Energy Drink 300ml",
      category: "drinks",
      price: 1000,
      image: p16 ,
      shopId: "shop015",
      shopName: "Dominos Pizza",
      
        vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
    },
    {
      id: 17,
      name: "Pepsi 500ml",
      category: "drinks",
      price: 1000,
      image: p17 ,
      shopId: "shop015",
      shopName: "Dominos Pizza",
      
        vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
    },
    {
      id: 18,
      name: "Shawarma Pizza",
      category: "loaded",
      price: 13760,
      image: p18 ,
      shopId: "shop015",
      shopName: "Dominos Pizza",
      
        vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
    },
    {
      id: 19,
      name: "Southern Style BBQ Chicken",
      category: "loaded",
      price: 14220,
      image: p19 ,
      shopId: "shop015",
      shopName: "Dominos Pizza",
      
        vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
    },
    {
      id: 20,
      name: "Suya BBQ Mix Grill Pizza ",
      category: "loaded",
      price: 13760,
      image: p20 ,
      shopId: "shop015",
      shopName: "Dominos Pizza",
      
        vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
    },
    {
      id: 21,
      name: "Teen Bitter Lemon 500ml",
      category: "drinks",
      price: 1000,
      image: p21 ,
      shopId: "shop015",
      shopName: "Dominos Pizza",
      
        vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
    },
    {
      id: 22,
      name: "The Lot",
      category: "loaded",
      price: 13760,
      image: p22 ,
      shopId: "shop015",
      shopName: "Dominos Pizza",
      
        vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
    },
    {
      id: 23,
      name: "Veggie Supreme Pizza",
      category: "veggie",
      price: 12400,
      image: p23 ,
      shopId: "shop015",
      shopName: "Dominos Pizza",
      
        vendorId: "waZTiIDGAPXFGSFMUcN2iXMmz0f2"
    },
   
    

    
  ];
  
  export default products;

  